import { render, staticRenderFns } from "./Patricia.vue?vue&type=template&id=a7634f54&scoped=true"
import script from "./Patricia.vue?vue&type=script&lang=js"
export * from "./Patricia.vue?vue&type=script&lang=js"
import style0 from "./Patricia.vue?vue&type=style&index=0&id=a7634f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7634f54",
  null
  
)

export default component.exports